<template>
  <div class="container-box">
    <div
      :class="[
        'container-objetivo cursor-pointer row',
        !_isVisible() ? 'unfocus' : 'container-objetivo-visible',
      ]"
      @click="selectObjetivo()"
      @mouseover="objetivoHover()"
      @mouseleave="ObjetivoLeave()"
      data-cy='objective'
    >
      <div class="visible-objetivo" v-if="adminMode">
        <q-checkbox
          data-cy="checkBox"
          color="primary"
          v-model="isVisible"
          @input="changeVisibility()"
        />
      </div>
      <div class="col-2 image">
        <q-img
          v-if="imgObjetivo"
          :src="imgObjetivo"
          :alt="imgObjetivo"
          class=""
        />
      </div>
      <span class="title col self-center" :style="colorFondo">
        {{ titleObjetivo }}
      </span>
      <span class="triangle" :style="colorTriangulo"></span>
    </div>
    <q-slide-transition>
      <div class="objetivo-container row q-pt-md q-pb-none" v-show="isSelected">
        <ConsecucionObjetivo v-if="showConsecucionObjetivo" :count="30" />

        <MetaContainer
          v-if="ciudadIndice"
          v-model="ciudadIndice"
          :objetivos="datos"
          :adminMode="adminMode"
        />
      </div>
    </q-slide-transition>
  </div>
</template>

<script>
import MetaContainer from '@/components/Metas/components/MetaContainer.vue';
import ConsecucionObjetivo from './ConsecucionObjetivo.vue';
import { QSlideTransition, QCheckbox, QImg } from 'quasar';
import Message from '@/components/shared/mixins/Message.js';
import Resources from '@/components/shared/mixins/Resources.js';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';

export default {
  mixins: [Message, Resources],
  components: {
    MetaContainer,
    ConsecucionObjetivo,
    QSlideTransition,
    QCheckbox,
    QImg
  },
  props: {
    datos: Object,
    metas: Array,
    idobjetivo: Number,
    adminMode: {
      type: Boolean,
      default: () => false
    },
    showConsecucionObjetivo: {
      type: Boolean,
      default: () => true
    },
    ciudadIndice: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      AUESelected: types.AUE_SELECTED
    }),
    titleObjetivo () {
      return `${this.datos.prefix}: ${this.datos.name}`;
    },
    imgObjetivo () {
      let res = this.searchResource(this.datos.file, 'imagen');

      return res ? res.url : this.getDefaultResource('imagen');
    },
    isSelected () {
      return this.AUESelected === this.datos.id;
    }
  },
  data () {
    return {
      colorFondo: {
        backgroundColor: `${this.datos.color}`
      },
      colorTriangulo: {
        borderBottomColor: `${this.datos.color}`
      },
      color: '',
      colorHover: '',
      isVisible: false
      // isSelected: false
    };
  },
  methods: {
    selectObjetivo () {
      if (!this._isVisible()) return;
      this.$emit('activeObjetivo', this.datos.id);
    },
    objetivoHover () {
      if (!this._isVisible()) return;
      this.colorFondo.backgroundColor = this.datos.colorHover;
      this.colorTriangulo.borderBottomColor = this.datos.colorHover;
    },
    ObjetivoLeave () {
      if (!this._isVisible()) return;
      this.colorFondo.backgroundColor = this.datos.color;
      this.colorTriangulo.borderBottomColor = this.datos.color;
    },
    _isVisible () {
      return this.ciudadIndice.visible;
    },
    changeVisibility () {
      this.$emit('updateVisibility', {
        idObj: this.datos.id,
        visibility: this.isVisible
      });
    }
  },
  watch: {
    datos: {
      handler: function () {
        this.colorFondo.backgroundColor = this.datos.color;
        this.colorTriangulo.borderBottomColor = this.datos.color;

        this.color = this.datos.color;
        this.colorHover = this.datos.colorHover;
      },
      deep: true
    },
    ciudadIndice: {
      handler: function (val) {
        this.ciudadIndice = val;
        this.isVisible = val.visible ? val.visible : false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container-box {
  color: #003f87;
  .visible-objetivo {
    margin: auto;
  }
  .unfocus {
    opacity: 0.57;
  }
  .container-objetivo {
    height: 82px;
    .image {
      height: 74px;
      width: 74px;
      margin: 4px;
      z-index: 2;
    }
    .title {
      align-items: center;
      border: 0;
      display: flex;
      font-size: 16px;
      font-weight: bold;
      height: 70px;
      margin: 4px 4px 4px -40px;
      padding: 0px 0px 0px 50px;
      position: relative;
      text-align: left;
      transition: all 0.2s ease;
      transition: background-color 0.3s;
      transition: box-shadow 2s;
      transition: width 0.5s;
      z-index: 1;
      color: #003f87;
    }
    .triangle {
      border-bottom: 70px solid transparent;
      border-right: 40px solid transparent;
      margin: 4px 0;
      padding: 0;
      left: -4px;
      top: 2px;
      height: 70px;
      position: relative;
    }
    .title,
    .triangle {
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1), 0 2px 0 0 rgba(0, 0, 0, 0.1);
    }
  }
  .container-objetivo-visible {
    &:hover {
      .image {
        width: 82px;
        height: 82px;
        margin: 0;
      }
      .title,
      .triangle {
        box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1), 0 3px 0 0 rgba(0, 0, 0, 0.1),
          0 4px 0 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}

/* MOVER LUEGO A SU SITIO */
.objetivo-container {
  margin: 0px 60px 0px 75px;
}

@media screen and (max-width: 499px) {
  .objetivo-container {
    margin: 0px 0px 0px 15px;
  }
}

@media (max-width: 640px) {
  .title {
    font-size: 10px !important;
    height: 42px !important;
    margin-left: -30px !important;
    padding-left: 35px !important;
  }
  .triangle {
    height: 0px !important;
    margin-top: 0px !important;
    border-bottom-width: 42px !important;
    border-right-width: 19px !important;
  }
  .image {
    height: 46px !important;
    width: 46px !important;
  }
  .container-objetivo{
    align-items: center !important;
  }

  .container-objetivo-visible {
    &:hover {
      .image {
        width: 52px !important;
        height: 52px !important;
      }
      .title,
      .triangle {
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1), 0 2px 0 0 rgba(0, 0, 0, 0.1),
          0 3px 0 0 rgba(0, 0, 0, 0.1) !important;
      }
    }
  }
}
</style>
